import { PBV3CycleTracker, PoisBountyUIVariant } from "interfaces";

export const getClassNameVariants = (
	isPage: boolean,
	isPortrait: boolean,
	variant: PoisBountyUIVariant
): (string | boolean)[] => {
	return [
		"pois-bounty-widget",
		isPage && "page-variant",
		!isPage && "mega-menu-variant",
		isPortrait && "portrait",
		variant
	];
};

export const getAllRewardsCollected = (
	tracker: PBV3CycleTracker | undefined
): boolean => {
	const maxCycles = tracker?.maxCycles;
	const normalizedMaxCycles = Number(maxCycles);

	return (
		tracker?.completed === true &&
		maxCycles !== undefined &&
		maxCycles !== null &&
		Number.isFinite(normalizedMaxCycles) &&
		normalizedMaxCycles === Number(tracker?.cycleIndex) + 1
	);
};
